<template>
    <div class="pitanje">
        <!-- navbar -->
        <navbar></navbar>

        <div class="container">
            <!-- counter pitanja -->
            <div class="counter">
                <counter :questions="questions" @counterAction="counterAction"></counter>
            </div>

            <!-- pitanje single -->
            <div class="p-single">
                <ProbnoPitanjeSingle ref="pitanjeSingle" :questions="questions"></ProbnoPitanjeSingle>
            </div>
        </div>

        <!-- partneri -->
        <partneri></partneri>

    </div>
</template>

<script>
import navbar from '../components/Navbar.vue'
import partneri from '../components/Partneri.vue'
import counter from '../components/ProbnoPitanjeCounter.vue'
import ProbnoPitanjeSingle from '../components/ProbnoPitanjeSingle.vue'
import exampleQuestions from '@/assets/probna-pitanja.json'

const RoundState = {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    FINISHED: 2
}

export default {
    name: 'probno-pitanje',
    data: function () {
        return {
            questions: exampleQuestions
        }
    },
    computed: {
        activeQuestionId () {
            return this.$store.state.exampleRoundQuestionId
        },
        questionId () {
            return this.$route.params.id
        },
        question () {
            return this.questions[this.questionId]
        },
        roundStatus () {
            return this.$store.state.exampleRoundStatus
        }
    },
    methods: {
        counterAction (payload) {
            try {
                let pitanjeSingle = this.$refs.pitanjeSingle
                pitanjeSingle.sendAnswer(payload.lastQuestion)
            } catch (error) {}
            if (payload.nextQuestion) {
                this.$store.state.exampleRoundQuestionId = payload.nextQuestion
                this.$router.replace(`/probno-pitanje/${payload.nextQuestion}`)
            } else {
                this.$store.state.exampleRoundStatus = RoundState.FINISHED
                this.$router.replace(`/probna-prijava-pitanja`)
            }
        }
    },
    mounted: function () {
        if (this.roundStatus === RoundState.NOT_STARTED) {
            this.$store.state.exampleRoundStatus = RoundState.IN_PROGRESS
            this.$store.state.exampleRoundQuestionId = 1
        }
        if (this.roundStatus === RoundState.IN_PROGRESS) {
            this.$router.replace(`/probno-pitanje/${this.activeQuestionId}`)
        } else {
            this.$router.replace(`/probna-prijava-pitanja`)
        }
    },
    components: {
        navbar,
        partneri,
        counter,
        ProbnoPitanjeSingle
    }
}
</script>

<style lang="scss" scoped>
.pitanje {
    padding-top: 14px;

    .counter {
        margin-bottom: 20px;
    }
    .p-single {
        margin-bottom: 20px;
    }
}

@media only screen and (min-width: 800px) {
    .pitanje {
        max-width: 880px;
        margin: auto;
    }
}
</style>
